'use strict';
/*eslint no-unused-vars: 0, no-extra-parens: 0*/
import React from 'react';
import { render } from 'react-dom';
import AppContainer from './containers/AppContainer';

// Entry point for web application
render(
    <AppContainer />,
    document.getElementById('hr-map-container')
);
